export enum EConflictMode {
    REWRITE = 'rewrite',
    RENAME = 'rename',
    STRICT = 'strict',
    SKIP = 'skip',
}
